import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';
import { APP_ZONES, NavigationOptionEnum } from '../workflow.type';
import { DummyRole } from '../workflow.v2.type';

export const onboardingNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> = new Map(
  [
    [
      ButtonActionType.CHECK_CUSTOMER_AND_CONTINUE_ONBOARDING,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_1]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_2]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.ONBOARDING_SUBMIT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
        [ActionButtonOutcomesType.PROCESSING]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_1]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_2]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_3]: defaultNavigationConfig,
        [ActionButtonOutcomesType.PRODUCT_UNAVAILABLE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.BUSINESS_ONBOARDING_SUBMIT,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
        [ActionButtonOutcomesType.PROCESSING]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_1]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_2]: defaultNavigationConfig,
        [ActionButtonOutcomesType.ALTERNATE_3]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.ONBOARDING_BANK_DETAILS_VERIFICATION,
      {
        [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
        [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      },
    ],
    [
      ButtonActionType.VERIFICATION_EDIT_INFORMATION,
      {
        [ActionButtonOutcomesType.SUCCESS]: {
          selectedZone: APP_ZONES.VERIFICATION,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'edit-information-name',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'forward',
        },
        [ActionButtonOutcomesType.FAILURE]: {
          selectedZone: APP_ZONES.VERIFICATION,
          selectedRole: DummyRole.EMPTY_ROLE,
          selectedPageIndex: 0,
          selectedPageUrl: 'edit-information-name',
          selectedPageId: '',
          tabRef: '',
          selectedBrowserBehaviour: '',
          externalUrl: '',
          selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          pageTransition: 'backward',
        },
      },
    ],
  ],
);
